<template>
  <div class="no-data">
    <div class="message-icon">
      <info-icon />
    </div>
    <div class="message" v-html="$t(message)" />
  </div>
</template>

<style scoped>
  .message-icon {
    margin-right: 32px;
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 4px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),
      0px 2px 1px -1px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    color: var(--secondary-color);
  }
</style>

<script>
import InfoIcon from '@/components/icons/InfoIcon.vue';

export default {
  name: 'no-data-message',
  props: {
    message: {
      type: String,
      default: 'provider.list.noData',
    },
  },
  components: {
    InfoIcon,
  },
};
</script>
